import { captureApiError } from "../monitoring/sentry.js";

export async function apiFetch(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    cache: "no-store",
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || "API request failed");
    error.status = response.status;
    error.details = data;
    captureApiError(error, path, response.status, { method: options.method || "GET" });
    throw error;
  }
  return data;
}
